module.exports = __webpack_public_path__ + "img/silo_img3.d35cefc6.jpeg";